import {
  normalizeMedicationDetail,
} from "../shared/childMedicationHelpers";
import { buildMedicationPlanCandidate } from "../../../features/careSourceProcessing/medicationPlanCandidates";

export const normalizeMedicationRecords = (records = []) => (
  Array.isArray(records)
    ? records
        .map((entry) => normalizeMedicationDetail(entry))
        .filter((entry) => entry.name)
    : []
);

export const resolveProfileMedicationDetails = ({
  medicationRecords = [],
} = {}) => normalizeMedicationRecords(medicationRecords);

export const buildMedicationReviewEditorState = ({
  medicationRecords = [],
  suggestion = null,
  source = {},
} = {}) => {
  const medicationDetails = normalizeMedicationRecords(medicationRecords);
  if (!suggestion?.name) {
    return { medicationDetails, medicationDraft: null, editingMedicationId: null };
  }

  const candidate = buildMedicationPlanCandidate({
    suggestion,
    source,
    existingMedications: medicationDetails,
  });

  return {
    medicationDetails,
    medicationDraft: normalizeMedicationDetail(candidate.nextMedication),
    editingMedicationId: candidate.matchedMedication?.id || null,
  };
};
